import { useState } from 'react';
import styled from 'styled-components';
import { useElements, useScene } from '../../../hooks';
import { ContainerInputGroup } from '../../common/inputGroups/ContainerInputGroup';
import { EffectsInputGroup } from '../../common/inputGroups/EffectsInputGroup copy';
import { PositioningInputGroup } from '../../common/inputGroups/PositioningInputGroup';
import { TextInputGroup } from '../../common/inputGroups/TextInputGroup';
import { SingleAccordion } from '../../generic/singleAccordion/SingleAccordion';
import { SingleAccordionItem } from '../../generic/singleAccordion/SingleAccordionItem';

export const StyleProps = ({
  variant,
  tab,
  pseudoclass,
}: {
  variant?: string;
  tab?: string;
  pseudoclass?: string;
}) => {
  const scene = useScene();
  const lastSelectedElement = scene.selectedElementIDs.slice(-1)[0];
  const [selectedElement] = useElements({ id: lastSelectedElement });

  const [colorPickerExtended, setColorPickerExtended] = useState(true);

  const isTextElement =
    selectedElement?.type === 'text' ||
    selectedElement?.type === 'variableText' ||
    selectedElement?.type === 'link';

  return (
    <Container>
      <SingleAccordion defaultValue="Container">
        {isTextElement && (
          <SingleAccordionItem
            item="Text"
            name={pseudoclass !== 'none' ? `Text (${pseudoclass})` : 'Text'}
          >
            <TextInputGroup
              {...{
                variant,
                tab,
                pseudoclass,
                colorPickerExtended,
                setColorPickerExtended,
              }}
            />
          </SingleAccordionItem>
        )}
        <SingleAccordionItem
          item="Container"
          name={
            pseudoclass !== 'none' ? `Container (${pseudoclass})` : 'Container'
          }
        >
          <PositioningInputGroup
            {...{
              variant,
              tab,
              pseudoclass,
            }}
          />

          <Separator />

          <ContainerInputGroup
            {...{
              variant,
              tab,
              pseudoclass,
              colorPickerExtended,
              setColorPickerExtended,
            }}
          />
        </SingleAccordionItem>
        <SingleAccordionItem
          item="Effects"
          name={pseudoclass !== 'none' ? `Effects (${pseudoclass})` : 'Effects'}
        >
          <EffectsInputGroup
            {...{
              variant,
              tab,
              pseudoclass,
              colorPickerExtended,
              setColorPickerExtended,
            }}
          />
        </SingleAccordionItem>
      </SingleAccordion>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Separator = styled.div`
  width: 100%;
  height: 20px;
`;
